import {
  OptionRecord,
  PartialScreenWithCoveragesRecord,
  ScreenWithCoverages,
} from "../../../types";

enum RoofPaymentScheduleOption {
  Default = "Default",
  Customizable = "Customizable",
}

const roofPaymentScheduleDescription: OptionRecord<
  RoofPaymentScheduleOption,
  PartialScreenWithCoveragesRecord
> = {
  [RoofPaymentScheduleOption.Default]: {
    [ScreenWithCoverages.PlanDetails]:
      "Increases the affordability of insurance by reducing coverage based on the age and material of your roofing.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Increases the affordability of insurance by reducing coverage based on the age and material of your roofing.",
    [ScreenWithCoverages.PolicySummary]:
      "Increase the affordability of insurance by reducing coverage based on the age and material of your roofing.",
  },
  [RoofPaymentScheduleOption.Customizable]: {
    [ScreenWithCoverages.PlanDetails]:
      "Increases the affordability of insurance by reducing coverage based on the age and material of your roofing.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Increases the affordability of insurance by reducing coverage based on the age and material of your roofing.",
    [ScreenWithCoverages.PolicySummary]:
      "Increase the affordability of insurance by reducing coverage based on the age and material of your roofing. You can deselect it in Extra coverages or Edit My Plan screens.",
  },
};

const roofPaymentScheduleTooltip: OptionRecord<
  RoofPaymentScheduleOption,
  PartialScreenWithCoveragesRecord
> = {
  [RoofPaymentScheduleOption.Default]: {
    [ScreenWithCoverages.PlanDetails]:
      "Increases the affordability of insurance by reducing coverage based on the age and material of your roofing.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Reduces coverage based on the age and material of roofing.",
    [ScreenWithCoverages.PolicySummary]:
      "Reduces coverage based on the age and material of roofing.",
  },
  [RoofPaymentScheduleOption.Customizable]: {
    [ScreenWithCoverages.PlanDetails]:
      "Reduces coverage based on the age and material of roofing.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Reduces coverage based on the age and material of roofing.",
    [ScreenWithCoverages.PolicySummary]:
      "Reduces coverage based on the age and material of roofing. You can deselect it in Extra coverages or Edit My Plan screens.",
  },
};

const getRoofPaymentScheduleDescription = (
  roofPaymentScheduleOption: RoofPaymentScheduleOption | undefined,
  screen: ScreenWithCoverages
): string | undefined =>
  roofPaymentScheduleOption
    ? roofPaymentScheduleDescription[roofPaymentScheduleOption]?.[screen]
    : roofPaymentScheduleDescription[RoofPaymentScheduleOption.Default][screen];

const getRoofPaymentScheduleTooltip = (
  roofPaymentScheduleOption: RoofPaymentScheduleOption | undefined,
  screen: ScreenWithCoverages
): string | undefined =>
  roofPaymentScheduleOption
    ? roofPaymentScheduleTooltip[roofPaymentScheduleOption]?.[screen]
    : roofPaymentScheduleTooltip[RoofPaymentScheduleOption.Default][screen];

export {
  RoofPaymentScheduleOption,
  getRoofPaymentScheduleDescription,
  getRoofPaymentScheduleTooltip,
};
